import React from "react";
import { Button, Intent } from "@blueprintjs/core";
import ConclusionPagination from "../ConclusionPagination";
import { translate } from "utlis/translations/i18n";

class PlayerConclusion extends React.Component {
  render() {
    const {
      session,
      current,
      conclusions = [],
      instance,
      onNextConclusion,
      onPrevConclusion,
      onFinishConclusion
    } = this.props;
    const { metadata } = session;
    const { type } = metadata;
    if (current >= conclusions.length || current < 0)
      return (
        <p>{translate('player.conclusionCouldNotBeDisplayed')}</p>
      );
    if (type === "PILOTED")
      return (
        <PilotedLayout
          session={session}
          conclusions={conclusions}
          instance={instance}
          onNextInterlude={onNextConclusion}
          onPrevInterlude={onPrevConclusion}
        />
      );
    if (type === "AUTONOMOUS")
      return (
        <AutonomousLayout
          session={session}
          conclusions={conclusions}
          instance={instance}
          onNextInterlude={onNextConclusion}
          onPrevInterlude={onPrevConclusion}
          onFinishConclusion={onFinishConclusion}
        />
      );
    return <div>{translate('player.unknownType')}</div>;
  }
}

class PilotedLayout extends React.Component {

  render() {
    const { conclusions, instance } = this.props;
    const { currentConclusion } = instance;
    const conclusionToShow = conclusions[currentConclusion];

    return (
      <div className="interlude-wrapper">
        {(!conclusionToShow.type ||
          conclusionToShow.type === "IMAGE") /** Use constants */ && (
            <img
              src={conclusionToShow.downloadURL}
              className="img-responsive"
              alt="Resource"
            />
          )}
        {conclusionToShow.type === "VIDEO" /** Use constants */ && (
          <video
            src={conclusionToShow.downloadURL}
            className="img-responsive"
            alt="Resource"
            controls={true}
          />
        )}
      </div>
    );
  }
}

class AutonomousLayout extends React.Component {
  isFirstInterlude = () => this.props.instance.currentConclusion === 0;
  isLastInterlude = () =>
    this.props.instance.currentConclusion ===
    this.props.session.data.conclusions.length - 1;

  render() {
    const {
      session,
      instance,
      onPrevInterlude,
      onNextInterlude,
      onFinishConclusion
    } = this.props;
    const { currentConclusion } = instance;

    const conclusionToShow = session.data.conclusions[currentConclusion];

    return (
      <div className="autonomous-layout row margin-top-large">
        <div className="col-xs-12 col-md-8">
          <div className="interlude-wrapper">
            {(!conclusionToShow.type ||
              conclusionToShow.type === "IMAGE") /** Use constants */ && (
                <img
                  src={conclusionToShow.downloadURL}
                  className="img-responsive"
                  alt="Resource"
                />
              )}
            {conclusionToShow.type === "VIDEO" /** Use constants */ && (
              <video
                src={conclusionToShow.downloadURL}
                className="img-responsive"
                alt="Resource"
                controls={true}
              />
            )}
          </div>
        </div>
        <div className="col-xs-12 col-md-4">
          <div className="interlude-control-wrapper">
            <div className="navigation">
              <div>
                {!this.isFirstInterlude() && (
                  <Button
                    text={translate('previous')}
                    icon="chevron-left"
                    intent={Intent.PRIMARY}

                    disabled={this.isFirstInterlude()}
                    onClick={onPrevInterlude}
                  />
                )}
              </div>
              <ConclusionPagination
                session={session}
                sessionInstance={instance}
              />
              <div>
                {this.isLastInterlude() && (
                  <Button
                  text={translate('next')}
                  rightIcon="tick"
                    intent={Intent.SUCCESS}
                    disabled={!this.isLastInterlude()}
                    onClick={onFinishConclusion}
                  />
                )}
                {!this.isLastInterlude() && (
                  <Button
                    text={translate('next')}
                    rightIcon="chevron-right"
                    intent={Intent.PRIMARY}
                    disabled={this.isLastInterlude()}
                    onClick={onNextInterlude}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PlayerConclusion;
